import i18next from 'i18next';
import Login from './Home';
import en from './i18n/en';
import tr from './i18n/tr';
import ar from './i18n/ar';

i18next.addResourceBundle('en', 'examplePage', en);
i18next.addResourceBundle('tr', 'examplePage', tr);
i18next.addResourceBundle('ar', 'examplePage', ar);

const HomeConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/home',
            component: Login
        }
    ]
};

export default HomeConfig;